/**
 * Classe com a funções para a lista de grupos na uncionalidade
 * de permissões de grupos.
 * @author: Adalto Junior <adaltojunior@sagaranatech.com>
 * Date: 18/09/13
 * Time: 17:10
 */


Greenmile.GroupPermissions = Greenmile.GroupPermissions || {};

Greenmile.GroupPermissions.ListGroup = function () {

    var selectorContainerList = "#GroupPermissions #listGroup";

    var listenerToItemsOfList = function () {

        var error                      = null,
            className                  = '',
            parentNode                 = this.parentNode,
            itemSelected               = this,
            groupId                    = null,
            classUIListItemSelected    = 'MonetUIListItemSelected',
            selectorUIListItemSelected = '.MonetUIListItemSelected',
            previousItemSelected       = null;

        try {

            previousItemSelected = parentNode.querySelector(selectorUIListItemSelected);

            if (previousItemSelected) {

                className = previousItemSelected.className;

                className = className.replace(classUIListItemSelected, '');

                previousItemSelected.className = className.trim();

            }

            itemSelected.className += ' ' + classUIListItemSelected;
            groupId = itemSelected.getAttribute('value');

            App.Views.GroupPermissions.renderContainerPermissions(groupId);

        } catch (e) {

            error = new Monet.Exception.ReturnError(this,
                'Error on listener to items of list');
            error.console();

        }

    };

    this.createContainerList = function () {

        var error = null,
            div   = null;

        try {

            div = document.createElement('div');

            div.setAttribute('id', 'listGroup');

            return div;

        } catch (e) {

            error = new Monet.Exception.ReturnError(this,
                'error on create container list.');
            error.console();

        }
    };

    this.createListGroup = function (data) {

        var error           = null,
            listContainer   = null,
            uiListComponent = null,
            conf            = {};

        try {

            uiListComponent = new Monet.UI.List();

            listContainer = document.querySelector(selectorContainerList);

            if (listContainer) {

                listContainer.innerHTML = '';

                conf.description = 'name';
                conf.action = listenerToItemsOfList;

                uiListComponent.conf = conf;
                uiListComponent.data = data;

                listContainer.appendChild(uiListComponent.render());

            }

        } catch (e) {

            error = new Monet.Exception.ReturnError(this,
                'Error on create list group.');
            error.console();

        }

    };

};